import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hourstoTimeSpan'
})
export class HourstoTimeSpanPipe implements PipeTransform {

    transform(hours: number): string {
        let hour = Math.floor(hours);
        let min = Math.floor((hours - hour) * 60);
        return `${hour < 10 && hour > 0 ? "0" + hour : hour}:${min < 10 && min > 0 ? "0" + min : min}:00`;
    }

}
